import React, { FC } from "react";
import NextImage from "next/image";
import type { ContentfulCallToActionType, ContentfulContactModalType } from "@/types";
import { ContentManager } from "../content-manager";
import { WhitePaperDownloadModal } from "./white-paper-download-modal";

interface WhitePaperDownloadCTAProps {
  cta: ContentfulCallToActionType;
  contentModal: ContentfulContactModalType
  pageSource: string;
}

export const WhitePaperDownloadCTA: FC<WhitePaperDownloadCTAProps> = ({ cta, contentModal, pageSource }) => {
  const [showContactModal, setShowContactModal] = React.useState(false);
  React.useEffect(() => {
    if (showContactModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showContactModal]);

  return (
    <section className="whitePaperDownload">
      <div className="wrapper wrapper_lg">
        <div className="cta whitePaperDownload--cta">
          <div className="cta--inner">
            {cta && cta.text && (
              <ContentManager
                content={cta.text}
                className="whitePaperDownload--cta--text"
              />
            )}

            {cta && cta.buttonLabel && (
              <>
                {/* TEMPORARY: External link instead of modal */}
                <a
                  className="link link_white link_full cta--link"
                  href="https://thepaymentsassociation.org/whitepaper/navigating-the-next-wave-of-cross-border-payments-can-innovation-conquer-the-challenges-ahead/" // ← change to your desired link
                  target="_blank"
                  rel="noopener noreferrer"
                  data-title={cta.buttonLabel}
                >
                  <span>{cta.buttonLabel}</span>
                </a>

                {/*
                ORIGINAL BUTTON — RESTORE WHEN READY
                <button
                  className="link link_white link_full cta--link"
                  onClick={() => {
                    setShowContactModal(true);
                  }}
                  data-title={cta.buttonLabel}
                >
                  <span>{cta.buttonLabel}</span>
                </button>
                */}
              </>
            )}
          </div>
          <NextImage
            src="/images/spiral-4.webp"
            alt="Spiral"
            width={1417}
            height={1653}
            role="presentation"
            draggable={false}
            className="whitePaperDownload--cta--spiral"
          />
        </div>
      </div>
      {showContactModal && (
        <WhitePaperDownloadModal
          {...contentModal}
          {...cta}
          onClose={() => {
            setShowContactModal(false);
          }}
          sourcePage={pageSource}
        />
      )}
    </section>
  )
};
